import {createContext} from 'react';

interface LoadingContextProps {
  setLoadingContext: (loading: boolean) => void;
  loading: boolean;
}

export const LoadingContext = createContext({} as LoadingContextProps);
